import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from "../../_services/api.integration";
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { User } from '../../_models/user';
import { Contacts } from "../../_models/contacts";
import { Shipment } from "../../_models/shipment";
import { Package } from "../../_models/package";
import { Router, ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { environment } from "../../../environments/environment";
import { Address } from '../../_models/address';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-shipment-create',
  templateUrl: './shipment-create.component.html',
  styleUrls: ['./shipment-create.component.css']
})
export class ShipmentCreateComponent implements OnInit {

  companyName: string;
  contactName: string;
  email: string;
  mobile: string;
  address1: string;
  city: string;
  state: string;
  zip: string;
  geo: string;
  createdBy: string;
  createdDate: string;
  packageType: string;
  pweight: string;
  boxHeight: string;
  boxWidth: string;
  boxLength: string;
  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  statusText5: string;
  statusText6: string;
  statusText7: string;
  statusText8: string;
  statusText9: string;
  statusText10: string;
  statusText11: string;
  statusText12: string;
  statusText13: string;
  statusText14: string;
  statusText16: string;
  address: Contacts = {};
  citiesList: any;
  addresses: Contacts[] = [];
  contacts: Contacts[] = [];
  contact: Contacts = {
    companyName: "",
    contactName: "",
    accountOwners: "",
    accountOwnerContacts: "",
    mobile: "",
    email: "",
    deliveryInstructions: "",
    status: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    geo: "",
    addressText: "",
    addressId: null,
    accountOwnerId: null,
    organizationId: null,
    accountOwnerContactId: null
  };
  selectedContact: Contacts = {};
  sp: Shipment = {};
  statusText: string;
  errorMessage: string;
  packages: Package[] = [];
  package: Package = {};

  newCustomerPopup: string = 'N';
  newPackagePopup: string = 'N';

  shipmentDetails: Array<Shipment>;
  ship: any;
  accountOwners: any;
  accountOwner: any;
  accountId: any;
  customerName: any;
  ownerName: any;
  noOfBoxes: number;
  statesList: any;
  packingType: Package = {
    length: "",
    height: "",
    width: "",
    packingType: "",
    weight: "",
    accountOwnerContactId: null
  };
  packingTypes: Array<Package>;

  constructor(private alertService: AlertService, private api: ApiIntegration,  public user: User, private http: HttpClient, private router: Router, private g: Globals) {
    this.g.page = "Create Shipments",
      this.shipmentDetails = [];
    this.cityList();
    this.stateList();
    this.packingTypes = [];
    this.api.getAccountOwners("1", "ACTIVE").subscribe((data: any) => {
      this.accountOwners = data.getAccountOwnersResponses;
    }, err => {
      this.alertService.error('Error', err);
    });
    if (this.user.role === "ACCOUNT_OWNER") {
      this.api.getAOContactsByStatusAndAOIdAndOrgId("1", this.user.accountOwnerId, "ACTIVE").subscribe((data: any) => {
        this.contacts = data;
      }, err => {
        this.alertService.error('Error', err);
      });
      this.api.getPackingTypesListAccount(this.user.accountOwnerId, "1").subscribe((data: any) => {
        this.packages = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }

  getList() {
    this.api.getAOContactsByStatusAndAOIdAndOrgId("1", this.accountOwner, "ACTIVE").subscribe((data: any) => {
      this.contacts = data;
    }, err => {
      this.alertService.error('Error', err);
    });
    this.api.getPackingTypesListAccount(this.accountOwner, "1").subscribe((data: any) => {
      this.packages = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  customSearchAccountOwner(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.ownerName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  customSearchFn(term: string, item: any = []) {
    term = term.toLowerCase();
    return item.contactName.toLowerCase().indexOf(term) > -1 || (item.companyName && item.companyName.toLowerCase().indexOf(term) > -1);
  }

  ngOnInit() {
  }

  selectContact() {
    this.statusText = "";
    if (this.selectedContact.contactName == '' || this.selectedContact.contactName === null || this.selectedContact.contactName === undefined || this.selectedContact.contactName === 'undefined') {
      this.statusText = 'Please Select Contact';
    }
  }

  typeNumber() {
    this.statusText16 = "";
    if (this.noOfBoxes === null || this.noOfBoxes === undefined) {
      this.statusText16 = 'Please enter no of boxes';
    }
  }

  validations() {
    if (this.selectedContact.contactName == '' || this.selectedContact.contactName === null || this.selectedContact.contactName === undefined || this.selectedContact.contactName === 'undefined') {
      this.statusText = 'Please Select Contact';
    }
    if (this.noOfBoxes === null || this.noOfBoxes === undefined) {
      this.statusText16 = 'Please enter no of boxes';
    }
    /*    if (this.sp.weight == '' || this.sp.weight === null || this.sp.weight === undefined || this.sp.weight === 'undefined') {
          this.statusText1 = 'Please Enter Weight';
        }
        if (this.sp.boxSize == '' || this.sp.boxSize === null || this.sp.boxSize === undefined || this.sp.boxSize === 'undefined') {
          this.statusText2 = 'Please Select BoxSize';
        } */
  }

  clear() {
    this.packingType = {};
    this.packingType.accountOwnerContactId = "";
    this.customerName = "";
    this.ownerName = "";
    this.packingType.length = "";
    this.packingType.width = "";
    this.packingType.weight = "";
    this.packingType.height = "";
    this.noOfBoxes = null;
    this.packingType = "";
    this.selectedContact = {};

  }

  removeShip(all) {
    let index = this.shipmentDetails.indexOf(all);
    this.shipmentDetails.splice(index, 1);
  }
  stateList() {
    this.api.getDistinctStates().subscribe((data: any) => {
      this.statesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }
  cityList() {
    this.api.getDistinctCity().subscribe((data: any) => {
      this.citiesList = data;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  changeStateAndCity() {
    this.api.getCityAndStateByPinCode(this.addresses[0].zip).subscribe((data: any) => {
      this.addresses[0].city = data.city;
      this.addresses[0].state = data.state;
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  addNewCustomer() {
    this.newCustomerPopup = 'Y';
  }

  addNewPackage() {
    this.newPackagePopup = 'Y';
  }


  cancelNewCustomer() {
    //this.address = null;
    this.newCustomerPopup = 'N';
    this.address.city = "";
    this.address.state = "";
    this.address.zip = "";
    this.address.geo = "";
    this.mobile = "";
    this.companyName = "";
    this.contactName = "";
    this.email = "";
    this.address.address1 = "";
  }

  cancelNewPackage() {
    this.newPackagePopup = 'N';
    this.packageType = "";
    this.pweight = "";
    this.boxHeight = "";
    this.boxWidth = "";
    this.boxLength = "";
  }

  clearCustomerFields() {
    this.companyName = "";
    this.contactName = "";
    this.email = "";
    this.mobile = null;
    this.address.address1 = "";
    this.address.city = "";
    this.address.state = "";
    this.address.zip = "";
    this.address.geo = "";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";
  }


  addShipment() {
    this.statusText = "";
    this.statusText16 = "";
    /*this.statusText2 = ""; */
    this.packingType.accountOwnerContactId = _.cloneDeep(this.selectedContact.accountOwnerContactId);
    this.packingType.contactName = _.cloneDeep(this.selectedContact.contactName);
    this.validations();
    if (this.statusText != "" || this.statusText16 !== '') {
      return false;
    } else {
      this.ship = _.cloneDeep(this.packingType);
      this.ship.noOfBoxes = this.noOfBoxes;
      let index = this.accountOwners.findIndex((d) => d.id === this.accountOwner);
      if (index > -1) {
        this.ship.customerName = this.accountOwners[index].ownerName;
      }
      this.shipmentDetails.push(this.ship);
      this.clear();
    }
  }

  createShipment() {
    if (this.user.role == "ACCOUNT_OWNER") {
      this.accountId = this.user.accountOwnerId;
    } else {
      this.accountId = this.accountOwner;
    }

    this.g.loaderDisplay = "display";
    if (this.shipmentDetails.length === 0) {
      this.statusText14 = 'please select minimum 1 contact';
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createShipHeaderAndLines', {
      "accountOwnerId": this.accountId,
      "organizationId": 1,
      "shipmentLines": this.shipmentDetails,
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shipment', 'Created Successfully');
          if (this.user.role == "ACCOUNT_OWNER") {
            this.router.navigate(['/admin/shipmentList']);
          } else {
            this.router.navigate(['/admin/adminShipmentList']);
          }
        } else if (data['code'] == 400) {
          this.alertService.error('Error', data['message']);

        } else {
          this.alertService.error('Error', "");
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          this.errorMessage = "detail: System error. Please speak to Support team";
        });
  }

  /*createShipment() {
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
    this.http.post(environment.apiUrl + 'api/createShipHeaderAndLines',{
        "accountOwnerId": this.user.accountOwnerId,
        "organizationId": 1,
        "shipmentLines": this.shipmentDetails,
        "status": "SUBMITTED"
      },
      {headers: header1}).subscribe(data => {
        if (data['code'] == 200) {
          if ( this.user.role == "ACCOUNT_OWNER" ) {
                              this.router.navigate(['/admin/shipmentList']);
                            } else {
                              this.router.navigate(['/admin/adminShipmentList']);
                            }
        } else if (data['code'] == 400){
            this.errorMessage = data['message'];
        }
      },
      (err: HttpErrorResponse) => {
      });
  }*/
  typeCompanyName() {
    this.statusText1 = "";
    if (this.companyName == '' || this.companyName === null || this.companyName === undefined || this.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
    }
  }

  typeName() {
    this.statusText2 = "";
    if (this.contactName == '' || this.contactName === null || this.contactName === undefined || this.contactName === 'undefined') {
      this.statusText2 = 'Please enter contact name';
    }
  }

  typeEmail() {
    this.statusText3 = "";
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email';
    }
  }

  typePhoneNumber() {
    this.statusText4 = "";
    if (this.mobile == '' || this.mobile === null || this.mobile === undefined || this.mobile === 'undefined') {
      this.statusText4 = 'Please enter phone number';
    }
  }

  typeAddress() {
    this.statusText5 = "";
    if (this.address.address1 == '' || this.address.address1 === null || this.address.address1 === undefined || this.address.address1 === 'undefined') {
      this.statusText5 = 'Please enter address';
    }
  }

  typeCity() {
    this.statusText6 = "";
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }
  }

  typeState() {
    this.statusText7 = "";
    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
  }

  typeZipCode() {
    this.statusText8 = "";
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter zip';
    }
  }

  submitContacts() {
    if (this.user.role == "ACCOUNT_OWNER") {
      this.accountId = this.user.accountOwnerId;
    } else {
      this.accountId = this.accountOwner;
    }

    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";
    this.statusText5 = "";
    this.statusText6 = "";
    this.statusText7 = "";
    this.statusText8 = "";

    if (this.companyName == '' || this.companyName === null || this.companyName === undefined || this.companyName === 'undefined') {
      this.statusText1 = 'Please enter company name';
    }
    if (this.contactName == '' || this.contactName === null || this.contactName === undefined || this.contactName === 'undefined') {
      this.statusText2 = 'Please enter contactName';
    }
    if (this.email == '' || this.email === null || this.email === undefined || this.email === 'undefined') {
      this.statusText3 = 'Please enter email';
    }

    if (this.mobile == '' || this.mobile === null || this.mobile === undefined || this.mobile === 'undefined') {
      this.statusText4 = 'Please enter phone number';
    }

    if (this.address.address1 == '' || this.address.address1 === null || this.address.address1 === undefined || this.address.address1 === 'undefined') {
      this.statusText5 = 'Please enter address';
    }
    if (this.address.city == '' || this.address.city === null || this.address.city === undefined || this.address.city === 'undefined') {
      this.statusText6 = 'Please enter city';
    }

    if (this.address.state == '' || this.address.state === null || this.address.state === undefined || this.address.state === 'undefined') {
      this.statusText7 = 'Please enter state';
    }
    if (this.address.zip == '' || this.address.zip === null || this.address.zip === undefined || this.address.zip === 'undefined') {
      this.statusText8 = 'Please enter zip';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 != "" || this.statusText4 != "" || this.statusText5 != "" || this.statusText6 != "" || this.statusText7 != "" || this.statusText8 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.addresses.push(this.address);
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createAccountOwnerContacts', {
      "accountOwnerId": this.accountId,
      "addresses": this.addresses,
      "createdBy": this.createdBy,
      "customerType": 'CUSTOMER',
      "createdDate": this.createdDate,
      "mobile": this.mobile,
      "companyName": this.companyName,
      "contactName": this.contactName,
      "email": this.email,
      "status": 'ACTIVE',
      "organizationId": 1
    },
      { headers: header1 }).subscribe((data: Contacts) => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shipment', 'Submitted Successfully');

          this.contacts.push(data);
          let newpack = [...this.contacts];
          this.contacts = [];
          this.contacts = newpack;
          this.contact = data;
          this.newCustomerPopup = 'N';
          this.cancelNewCustomer();
        } else {
          this.alertService.error('Error', "...");
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  typePackageType() {
    this.statusText9 = "";
    if (this.packageType == '' || this.packageType === null || this.packageType === undefined || this.packageType === 'undefined') {
      this.statusText9 = 'Please enter package type';
    }
  }

  typeLength() {
    this.statusText10 = "";
    if (this.boxLength == '' || this.boxLength === null || this.boxLength === undefined || this.boxLength === 'undefined') {
      this.statusText10 = 'Please enter length';
    }
  }

  typeWidth() {
    this.statusText11 = "";
    if (this.boxWidth == '' || this.boxWidth === null || this.boxWidth === undefined || this.boxWidth === 'undefined') {
      this.statusText11 = 'Please enter width';
    }
  }

  typeHeight() {
    this.statusText12 = "";
    if (this.boxHeight == '' || this.boxHeight === null || this.boxHeight === undefined || this.boxHeight === 'undefined') {
      this.statusText12 = 'Please enter height';
    }
  }

  typeWeight() {
    this.statusText13 = "";
    if (this.pweight == '' || this.pweight === null || this.pweight === undefined || this.pweight === 'undefined') {
      this.statusText13 = 'Please enter weight';
    }
  }


  submitPackage() {
    if (this.user.role == "ACCOUNT_OWNER") {
      this.accountId = this.user.accountOwnerId;
    } else {
      this.accountId = this.accountOwner;
    }

    this.g.loaderDisplay = "display";
    this.statusText9 = "";
    this.statusText10 = "";
    this.statusText11 = "";
    this.statusText12 = "";
    this.statusText13 = "";

    if (this.packageType == '' || this.packageType === null || this.packageType === undefined || this.packageType === 'undefined') {
      this.statusText9 = 'Please enter package type';
    }
    if (this.boxLength == '' || this.boxLength === null || this.boxLength === undefined || this.boxLength === 'undefined') {
      this.statusText10 = 'Please enter length';
    }
    if (this.boxWidth == '' || this.boxWidth === null || this.boxWidth === undefined || this.boxWidth === 'undefined') {
      this.statusText11 = 'Please enter width';
    }
    if (this.boxHeight == '' || this.boxHeight === null || this.boxHeight === undefined || this.boxHeight === 'undefined') {
      this.statusText12 = 'Please enter height';
    }

    if (this.pweight == '' || this.pweight === null || this.pweight === undefined || this.pweight === 'undefined') {
      this.statusText13 = 'Please enter weight';
    }

    if (this.statusText9 != "" || this.statusText10 != "" || this.statusText11 != "" || this.statusText12 != "" || this.statusText13 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/createPackingTypes', {
      "packingType": this.packageType,
      "weight": this.pweight,
      "height": this.boxHeight,
      "length": this.boxLength,
      "width": this.boxWidth,
      "organizationId": 1,
      "accountOwnerId": this.accountId
    },
      { headers: header1 }).subscribe((data: Package) => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Package', 'Submitted Successfully');

          this.packages.push(data);
          let newpack = [...this.packages];
          this.packages = [];
          this.packages = newpack;

          // alert("sadasd:" + this.package);
          //console.log("sadasd:" + this.package);
          this.package = data;
          this.newPackagePopup = 'N';
          this.cancelNewPackage();
        } else {
          this.alertService.error('Error', "...");
        }

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  };

  allowNumbersonly(noOfBoxes) {
    console.log(noOfBoxes);
  }

  getContactAddress() {
  }

}
